export default __webpack_public_path__ + "2ac05b18402fe04ff27448bab889d3c1.png";